"use client";

import { SectionTitle } from "./sectionTitle";

export const Sponsors = () => {
	return (
		<div className="flex flex-col gap-4">
			<SectionTitle title="主催" />

			<div className="flex items-center gap-4">
				<div className="bg-white p-6 w-80 h-24 flex items-center justify-center">
					<img
						src="/events/suzuka2025/suzuka.svg"
						alt="鈴鹿高専ロゴ"
						className="w-80 h-60 object-contain"
					/>
				</div>
			</div>

			<div className="mt-2">
				<p className="text-black font-bold font-zenMaru text-xl text-left mb-2">
					独立行政法人国立高等専門学校機構 鈴鹿工業高等専門学校
				</p>
			</div>
		</div>
	);
};
